import React from 'react';
import { Grid } from '@mui/material';
import { KpiCard } from 'dashboard/components/common';

/**
 * Top-of-page KPI strip used on the webpage / stage dashboards. The
 * caller passes a `data` array of `{title, value, icon}` rows and we
 * lay them out as KPI cards.
 */
export default function AnalysisHeader({ data }) {
  if (!data || data.length === 0) return null;
  return (
    <Grid container spacing='20px' mb='20px'>
      {data.map((item, idx) => (
        <Grid item xs={12} md={6} xl={4} key={idx}>
          <KpiCard
            label={item.title}
            value={item.value}
            hint='Since last month'
            accent='#422AFB'
          />
        </Grid>
      ))}
    </Grid>
  );
}
